<div class="change-request-list">
  <ng-container *ngIf="deliverables$ | async as deliverables">
    <ng-container *ngIf="deliverables.length; else noChanges">
      <scope-by-work-table
        [scopeVersion]="currentScope"
        [currentChangeRequest]="currentChangeRequest"
        [isEditable]="false"
        [showNetChanges]="true"
        [mainColumnClass]="mainColumnClass"
        [componentMainColumnClass]="componentMainColumnClass"
        [roleMainColumnClass]="roleMainColumnClass"
        [sortedSections]="sections$ | async"
        [sortedDefaultSectionDeliverables]="deliverables"
        [cdnConfig]="cdnConfig" />
    </ng-container>
  </ng-container>

  <ng-template #noChanges>
    <div class="no-changes">
      <mat-icon class="material-symbols-rounded">info</mat-icon>
      <span>No net changes to display</span>
    </div>
  </ng-template>
</div>
